export enum DealForm {
  Player = 'PLAYER',
  SellingClub = 'SELLING_CLUB',
}

export enum PlayerRepresentation {
  SelfRepresentation = 'SELF_REPRESENTATION',
  Agent = 'AGENT',
}
